import { render, staticRenderFns } from "./RoundPhotoFrame.vue?vue&type=template&id=930f8604&"
import script from "./RoundPhotoFrame.vue?vue&type=script&lang=js&"
export * from "./RoundPhotoFrame.vue?vue&type=script&lang=js&"
import style0 from "./RoundPhotoFrame.vue?vue&type=style&index=0&id=930f8604&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports